import { createAction, props } from '@ngrx/store';

export enum ActionKeys {
    Loading = '[Escalation UI] Loading',
}

export const uiLoading = createAction(ActionKeys.Loading, props<{ loading: boolean }>());
